<table [hidden]="datePicker.currentMode !== 'month'"
       class="td-wb-month-picker__table"
       role="grid"
       [attr.aria-labelledby]="datePicker.uniqueId + '-month-title'"
       [attr.aria-activedescendant]="datePicker.activeDateId() || null">
  <thead>
  <tr>
    <th class="td-wb-table__cell--right">
      <button tdWbDatePickerButton
              [tdWbFocusOnDisabled]="yearButtonRef()"
              class="td-wb-left td-wb-month-picker__arrow-button"
              type="button"
              (click)="datePicker.move(-1)"
              [disabled]="navPrevDisabled()"
              [attr.aria-label]="'tdWb.monthPicker.PREVIOUS_YEAR' | tdWbTranslate">
        <td-wb-icon class="td-wb-day-picker__icon"
                    iconId="arrow-left"
                    size="9x14" />
      </button>
    </th>
    <th>
      <strong class="td-wb-vh"
              [id]="datePicker.uniqueId + '-month-title'"
              aria-live="assertive"
              role="heading"
              aria-level="1"
              [innerText]="title()">
      </strong>
      <button tdWbDatePickerButton
              #yearButton
              type="button"
              class="td-wb-full-width"
              (click)="datePicker.toggleMode(0)"
              [attr.aria-label]="'tdWb.monthPicker.VIEW_YEAR_CALENDAR' | tdWbTranslate">
            <span class="td-wb-date-picker-header"
                  [innerText]="title()"></span>
      </button>
    </th>
    <th class="td-wb-table__cell--left">
      <button tdWbDatePickerButton
              [tdWbFocusOnDisabled]="yearButtonRef()"
              class="td-wb-left td-wb-month-picker__arrow-button"
              type="button"
              (click)="datePicker.move(1)"
              [disabled]="navNextDisabled()"
              [attr.aria-label]="'tdWb.monthPicker.NEXT_YEAR' | tdWbTranslate">
        <td-wb-icon class="td-wb-day-picker__icon"
                    iconId="arrow-right"
                    size="9x14" />
      </button>
    </th>
  </tr>
  </thead>
  <tbody>
    @for (row of rows(); track rowIndex; let rowIndex = $index) {
      <tr>
        @for (dt of row; track dt.uid) {
          <td class="td-wb-table__cell--center"
              role="gridcell"
              [id]="dt.uid"
              [attr.aria-disabled]="dt.disabled">
            <button tdWbDatePickerButton
                    type="button"
                    class="td-wb-month-picker__button"
                    [class.td-wb-date-picker-button--active]="dt.selected"
                    [disabled]="dt.disabled"
                    (click)="datePicker.select(dt.date)">
            <span [class.text-info]="dt.current"
                  [innerText]="dt.label"></span>
            </button>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
